import { LO } from 'big-l';
import { Model } from 'katal3-lib';
export class Provider extends Model {
    update(httpProvider) {
        super.update(LO.pick(httpProvider, ['_id', 'uid', 'name']));
    }
}
